module.exports = __webpack_public_path__ + "static/FoodStartup2018-2f5e9cb292ee0d31fd7e13946684729a.png";